export default class ImagemCardHeader {
  constructor(srcImg, title, alt, width, height) {
    this.srcImg = srcImg;
    this.title = title;
    this.alt = alt;
    this.width = width;
    this.height = height;
  }
}
